<template>
  <div>
    <b-row>
      <b-col>
        <h1>{{ $route.params.logicsetname }}</h1>       
      </b-col>
      <b-col>
        <b-icon v-if="isBusy" icon="arrow-clockwise" animation="spin" font-scale="1"></b-icon>
      </b-col>
      <b-col>
        <b-button-group>
          <b-button v-if="!isBusy" variant="danger" @click="removeLogicSet()">Ta bort</b-button>
        </b-button-group>
      </b-col>
    </b-row>

    <b-card>
      <tableedit v-if="recs" v-bind:recs="recs" v-bind:cols="GetCols(false)" v-on:save="onsave" v-on:cancel="oncancel">
      </tableedit>
    </b-card>
  </div>
</template>
<script>
import tableedit from "./tableedit";
import { Api } from "../../lib/api";
const api = new Api();

export default {
  name: "logicsetedit",
  components: { tableedit },
  data() {
    return {
      recs: Array,
      cols: Array,
      isBusy: false,
    };
  },
  created() {
    console.log("logicsetedit created");
    // console.log($route.params.logicsetname);
    // console.log($route.params.logictype);    
    this.GetData();
  },
  methods: {
    GetCols(onlyWithData) {
      if (!this.cols) return [];
      var res = this.cols.filter(x => x.field != 'TenantCode');
      if (!onlyWithData) return res;

      return res.filter((x) => x.hasData);
    },
    GetData() {
      this.isBusy = true;
      var p = api.params({
        LogicTypeName: this.$route.params.logictype,
        LogicSet: this.$route.params.logicsetname,
      });
      //const url = "/api/apiConfiguration/GetLogicSet?";
      const url = "/api/Configuration/GetLogicSet?";

      api.get(url + p).then((result) => {
        //this.logicset = result.data;
        var res = result.data;
        this.cols = res.columns;
        var recs = [];
        for (var i = 0; i < res.records.length; i++) {
          var it = res.records[i];
          var r = { recid: it.recid };
          for (var x = 0; x < res.columns.length; x++) {
            var v = it.values[x];
            var colName = res.columns[x].field;
            if (v != null && v != undefined && v != "") {
              if (v.v != undefined && v.v != null) r[colName] = v.v;
              if (v.l != undefined && v.l != null) {
                r[colName] = v.l.text; //OBS! Måste kollas
              }
              if (r[colName]) res.columns[x].hasData = true;
            }
          }
          recs.push(r);
        }
        this.recs = recs;
        this.isBusy = false;
      });
    },
    removeLogicSet() {
      if(!this.isBusy)
        this.save([]);
    },
    onsave(data) {
      if(confirm("Vill du spara eventuella förändringar?")) {
        this.save(data);
      }
    },
    save(data) {
      this.isBusy = true;
      console.log(data);
      //alert("Ej implementerat");
      var p = {
        logicType: this.$route.params.logictype,
        logicSet: this.$route.params.logicsetname,
        records: [],
        columnNames: this.cols.map((x) => x.field),
      };
      data.forEach((r) => {
        var newRow = [];
        p.columnNames.forEach((c) => {
          var nc = r[c];
          if (nc) newRow.push(nc);
          else newRow.push("");
        });
        p.records.push(newRow);
      });
      if (p.records.length == 0) {
        var msg =
          "Vill du verkligen ta bort hela logikuppsättningen? OBS! GÅR EJ ATT ÅNGRA!";
        if (!confirm(msg)) return;
      }
      //const url = "/api/apiConfiguration/Save";
      const url = "/api/Configuration/Save";
      api.post(url, p).then((res) => {
        if (res.data) {
          alert(res.data);
          return;
        }
        this.$router.go(-1);
        this.isBusy = false;
      });
    },
    oncancel() {
      if(confirm("Vill du avbryta och slänga eventuella förändringar?")) {
            this.cancel();
        }
    },
    cancel() {
      if (!this.isBusy) {
        this.isBusy = false;
        this.$router.go(-1);
      }
    },
  },
};
</script>